import Skills from "../components/Skills"
import SectionHeader from "../components/SectionHeader"

export default function Home(){
    return (
        <div className = "flex items-center justify-center flex-col min-h-screen w-full py-16">

            <SectionHeader title = "My Skills" />

            <div className = "flex flex-row flex-wrap max-w-6xl mx-auto my-8 gap-x-8 gap-y-20 items-center justify-center">

                <Skills name = "Languages" icon = "languages" delay = {0} duration = {7} offsetX = {-8} offsetY = {-26}
                skills = {["Python", "JavaScript/TypeScript", "HTML", "CSS", "Java", "C/C++", "R", "Rust"]}></Skills>

                <Skills name = "Web & App Development" icon = "web" delay = {-1.4} duration = {7.6} offsetX = {6} offsetY = {22}
                skills = {["Express.js", "Flask", "FastAPI", "Node.js", "React.js/Next.js", "Spring Boot"]}></Skills>

                <Skills name = "Data & Machine Learning" icon = "data" delay = {-2.8} duration = {6.4} offsetX = {-6} offsetY = {-32}
                skills = {["SQL", "MongoDB", "Pandas", "NumPy", "Scikit-learn", "PyTorch"]}></Skills>

                <Skills name = "Cloud Development" icon = "cloud" delay = {-0.7} duration = {8} offsetX = {8} offsetY = {28}
                skills = {["EC2", "Lambda", "ALB", "ECS", "EKS", "CloudFormation", "CDK", "CodeDeploy"]}></Skills>

                <Skills name = "Cloud Security & Monitoring" icon = "security" delay = {-3.5} duration = {7.2} offsetX = {-8} offsetY = {-20}
                skills = {["IAM", "VPC", "CloudWatch", "SQS", "SNS", "X-Ray"]}></Skills>

                <Skills name = "AI Engineering" icon = "ai" delay = {-2.1} duration = {6.8} offsetX = {6} offsetY = {30}
                skills = {["Claude", "Cursor", "Copilot", "HuggingFace", "Pinecone", "FAISS", "LangChain", "LlamaIndex"]}></Skills>

                <Skills name = "Tooling" icon = "tooling" delay = {-4.2} duration = {7.4} offsetX = {-4} offsetY = {-16}
                skills = {["Docker", "Kubernetes", "Git/GitHub", "Linux", "CUDA"]}></Skills>

            </div>

        </div>
    )
}
